import OfflineOrderConstants from './OfflineOrders.constants';
const initialState = {
  selectedStores: [],
  isInactiveChannelEnabled: false,
  allChannels: true,
  channels: []
};

const OfflineOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case OfflineOrderConstants.APPLIED_STORE_FILTER:
      return action.payload;

    default:
      return state;
  }
};

export default OfflineOrderReducer;
